import { Action } from '../../actions';
import { CHANGE_PAGE_ID_CAMPAIGN_PLACE_EDITOR } from '../../actions/campaignPlaceEditor/changePageIdCampaignPlaceEditor';
import { CHANGE_PLACE_ID_CAMPAIGN_PLACE_EDITOR } from '../../actions/campaignPlaceEditor/changePlaceIdCampaignPlaceEditor';
import { CLOSE_CAMPAIGN_PLACE_EDITOR } from '../../actions/campaignPlaceEditor/closeCampaignPlaceEditor';
import { INIT_CAMPAIGN_PLACE_EDITORS } from '../../actions/campaignPlaceEditor/initCampaignPlaceEditors';
import { OPEN_CAMPAIGN_PLACE_EDITOR } from '../../actions/campaignPlaceEditor/openCampaignPlaceEditor';
import { REVERT_CAMPAIGN_PLACE_EDITOR } from '../../actions/campaignPlaceEditor/revertCampaignPlaceEditor';
import { SHOW_ERRORS_CAMPAIGN_PLACE_EDITOR } from '../../actions/campaignPlaceEditor/showErrorsCampaignPlaceEditor';
import { CampaignPlaceEditorState } from '../../typings/campaignPlaceEditor';

import { changePageIdCampaignPlaceEditor } from './changePageIdCampaignPlaceEditor';
import { changePlaceIdCampaignPlaceEditor } from './changePlaceIdCampaignPlaceEditor';
import { closeCampaignPlaceEditor } from './closeCampaignPlaceEditor';
import { initCampaignPlaceEditors } from './initCampaignPlaceEditors';
import { openCampaignPlaceEditor } from './openCampaignPlaceEditor';
import { revertCampaignPlaceEditor } from './revertCampaignPlaceEditor';
import { showErrorsCampaignPlaceEditor } from './showErrorsCampaignPlaceEditor';

export const campaignPlaceEditor = (state: CampaignPlaceEditorState = {}, action: Action): CampaignPlaceEditorState => {
    switch (action.type) {
        case INIT_CAMPAIGN_PLACE_EDITORS:
            return initCampaignPlaceEditors(state, action);
        case OPEN_CAMPAIGN_PLACE_EDITOR:
            return openCampaignPlaceEditor(state, action);
        case CLOSE_CAMPAIGN_PLACE_EDITOR:
            return closeCampaignPlaceEditor(state, action);
        case CHANGE_PAGE_ID_CAMPAIGN_PLACE_EDITOR:
            return changePageIdCampaignPlaceEditor(state, action);
        case CHANGE_PLACE_ID_CAMPAIGN_PLACE_EDITOR:
            return changePlaceIdCampaignPlaceEditor(state, action);
        case REVERT_CAMPAIGN_PLACE_EDITOR:
            return revertCampaignPlaceEditor(state, action);
        case SHOW_ERRORS_CAMPAIGN_PLACE_EDITOR:
            return showErrorsCampaignPlaceEditor(state, action);
        default:
            return state;
    }
};
